<!-- Modals -->
<ui-dialog
    [open]="currentlyOpenDialog === 'EMPLOYMENT_INFO'"
    [form]="formEmploymentInformation?.form"
    (primaryButtonPressed)="
        submitForm(formEmploymentInformation ?? formEmploymentInformationCustom, !formEmploymentInformation)
    "
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    secondaryButtonLabel="cancel"
    (closing)="onCancel()"
    header="edit"
    size="small"
    [stickyButtons]="true"
    [stickyHeader]="true"
>
    <app-form-employment-information
        *permission="editEmploymentPermission"
        #formEmploymentInformation
        [employee]="employee"
    >
    </app-form-employment-information>

    <app-form-data-fields
        *ngIf="currentlyOpenDialog === 'EMPLOYMENT_INFO'"
        #formEmploymentInformationCustom
        [employee]="employee"
        [dataFieldGroup]="defaultGroupFieldNames.employment_information"
        [dataFields]="editableDataFields"
        [(dataValues)]="dataValues"
        [isDefaultGroup]="true"
    ></app-form-data-fields>
</ui-dialog>

<app-deprecated-modal-form
    #createSalary
    headerText="employees.jobAndPay.newCompensation"
    [disabled]="formSalary.disabled"
    [thin]="true"
    [form]="formSalary"
    (save)="onSaveSalary(formSalary.salary, formSalary)"
    (cancel)="onCancel()"
>
    <app-form-salary #formSalary [employee]="employee"></app-form-salary>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editSalaryModal
    headerText="employees.jobAndPay.editCompensation"
    [disabled]="formEditSalary.disabled"
    [thin]="true"
    [form]="formEditSalary"
    (save)="onSaveSalary(formEditSalary.salary, formEditSalary)"
    (cancel)="onCancel()"
>
    <app-form-salary #formEditSalary [employee]="employee"></app-form-salary>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #addAdditionalIncome
    headerText="employees.jobAndPay.addIncomeType"
    [thin]="true"
    [form]="formAddAdditionalIncome"
    (save)="
        onSaveAdditionalIncomeType(formAddAdditionalIncome.companyAdditionalIncome.employeeAdditionalIncomes[0]);
        formAddAdditionalIncome.reset()
    "
    (cancel)="onCancel(); formAddAdditionalIncome.companyAdditionalIncome = null; formAddAdditionalIncome.reset()"
>
    <app-form-add-additional-income #formAddAdditionalIncome></app-form-add-additional-income>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editAdditionalIncome
    (cancel)="onCloseAdditionalIncomeEdit()"
    [showButtons]="false"
    headerText="employees.jobAndPay.editAdditionalIncomeTypes"
    [form]="formEditAdditionalIncome"
>
    <app-form-edit-additional-income
        [pendingPayrollExists]="pendingPayrollExists"
        [companyAdditionalIncomes]="activeCompanyAdditionalIncomes"
        [modalContainer]="editAdditionalIncome"
        #formEditAdditionalIncome
    ></app-form-edit-additional-income>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #createTaxCredit
    [form]="formTaxCredit"
    (save)="onSaveLegacyTaxCredit(formTaxCredit.taxCredit)"
    (cancel)="onCancel()"
>
    <app-deprecated-form-tax-credit #formTaxCredit></app-deprecated-form-tax-credit>
</app-deprecated-modal-form>

<app-deprecated-modal-form #editFormAdditionalTax [form]="formAdditionalTax" (save)="onSave()" (cancel)="onCancel()">
    <app-form-additional-tax #formAdditionalTax [payrollEmployee]="payrollEmployee"></app-form-additional-tax>
</app-deprecated-modal-form>

<app-deprecated-modal-form #editFormBankAccount [form]="formBankAccount" (save)="onSave()" (cancel)="onCancel()">
    <app-form-bank-account
        #formBankAccount
        [bankAccount]="bankAccount"
        [employee]="employee"
        [bankingInformationRequiredByDefault]="bankingInformationRequiredByDefault"
        *permission="editBankAccountPermission"
    >
    </app-form-bank-account>

    <app-form-data-fields
        *ngIf="editFormBankAccount.isOpen"
        [employee]="employee"
        [dataFieldGroup]="defaultGroupFieldNames.bank_account"
        [dataFields]="editableDataFields"
        [(dataValues)]="dataValues"
        [isDefaultGroup]="true"
    ></app-form-data-fields>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editDataFieldsModal
    [form]="editDataFieldsForm"
    (save)="onDataFieldsSave()"
    (cancel)="onCancel()"
>
    <app-form-data-fields
        #editDataFieldsForm
        [employee]="employee"
        [dataFieldGroup]="editFieldGroup"
        [dataFields]="editableDataFields"
        [(dataValues)]="dataValues"
    ></app-form-data-fields>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #confirmDeleteSalary
    [negative]="true"
    label="employees.jobAndPay.deleteCompensation"
    description="employees.jobAndPay.wouldYouLikeToDeleteThisCompensation"
></app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #confirmDeleteTaxCredit
    [negative]="true"
    label="employees.jobAndPay.deleteTaxCredit"
    description="employees.jobAndPay.wouldYouLikeToDeleteThisTaxCredit"
></app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #confirmEnablePayroll
    label="employees.jobAndPay.addToPayroll"
    description="employees.jobAndPay.onceAnEmployeeIsAddedToPayrollYouWillNotBeAbleToRemoveThem"
>
</app-deprecated-confirmation-dialog>

<ui-dialog
    *ngIf="employeeVacationPayMethod && payrollEnabled && employee?.activeOnPayroll"
    #editVacationPayMethod
    formDialog
    size="small"
    header="{{ 'employees.jobAndPay.editVacationPayMethod' | translate }}"
    [scrollable]="true"
    [primaryButtonLabel]="'Save'"
    (primaryButtonPressed)="
        onSaveEmployeeVacationPayMethod(formEditVacationPayMethod.employeeVacationPayMethod, formEditVacationPayMethod)
    "
    [open]="displayEditVacationPayMethodModal"
    (secondaryButtonPressed)="
        employee?.vacationPayMethod
            ? (formEditVacationPayMethod.employeeVacationPayMethod = employee.vacationPayMethod)
            : (formEditVacationPayMethod.employeeVacationPayMethod = 'vacation_accrual');
        shouldEditVacationPayMethodModalBeDisplayed(false)
    "
    (closing)="
        employee?.vacationPayMethod
            ? (formEditVacationPayMethod.employeeVacationPayMethod = employee.vacationPayMethod)
            : (formEditVacationPayMethod.employeeVacationPayMethod = 'vacation_accrual');
        shouldEditVacationPayMethodModalBeDisplayed(false)
    "
>
    <app-employee-vacation-pay-method-form
        #formEditVacationPayMethod
        [employee]="employee"
        [pendingPayrollExists]="pendingPayrollExists"
    ></app-employee-vacation-pay-method-form>
</ui-dialog>

<ng-template #displayDash>
    <span>-</span>
</ng-template>
<ng-template #displayRegularPay>
    <span>{{ 'employees.jobAndPay.regularPay' | translate }}</span>
</ng-template>
<!-- Body -->
<div class="page-container inner-padding" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" [withMargin]="false" (isLoading)="isLoading = $event">
        <div class="buttons">
            <ng-container *ngIf="canCreateChangeRequest">
                <ui-button type="outline" [matMenu]="changeRequestMenu"
                    >{{ 'employees.jobAndPay.requestChange' | translate }} <mat-icon svgIcon="chevronDown"></mat-icon>
                </ui-button>
                <mat-menu #changeRequestMenu="matMenu">
                    <button
                        *ngFor="let template of changeRequestTemplates"
                        mat-menu-item
                        [routerLink]="['/change-requests', 'templates', template.id, 'employees', employee.id, 'new']"
                    >
                        {{ template.name | appTranslateOptions: changeRequestTemplate }}
                    </button>
                </mat-menu>
            </ng-container>
        </div>
    </app-employee-header>

    <div
        *ngIf="payrollEnabled && employee.isPayrollSyncEnabled && jobAndPayWarningProvider?.warningsToDisplay()?.length"
    >
        <app-warning-banner
            header="There are issues that may prevent the employee from being paid"
            [warningsToDisplayProvider]="jobAndPayWarningProvider"
            [withMargin]="false"
        ></app-warning-banner>
    </div>

    <div class="profile-layout">
        <div class="profile-layout-sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>
        <div class="profile-layout-content">
            <ui-card
                [withMargin]="false"
                *permission="viewEmploymentPermission"
                role="group"
                aria-labelledby="employment-info-header"
            >
                <ui-button
                    type="link"
                    *ngIf="canShowEditEmploymentInformation"
                    (click)="currentlyOpenDialog = 'EMPLOYMENT_INFO'"
                    class="edit"
                    >{{ 'employees.jobAndPay.edit' | translate }}
                </ui-button>
                <app-segment-header
                    id="employment-info-header"
                    title="{{ 'employees.jobAndPay.employmentInformation' | translate }}"
                ></app-segment-header>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.dateHired' | translate }}</label>
                    </div>
                    <div class="columns-7">
                        {{ employee?.hiredAt | appDate: 'mediumDate' }}
                        <span class="margin-left-2" *ngIf="employee?.lengthOfService"
                            >({{ employee?.lengthOfService }})</span
                        >
                    </div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.reportsTo' | translate }}</label>
                    </div>
                    <div class="columns-7">
                        <a
                            *ngIf="employee?.manager; else noManager"
                            [routerLink]="['/employees', 'directory', employee?.manager?.id]"
                            >{{ employee?.manager?.fullName }}</a
                        >
                        <ng-template #noManager>{{ 'employees.jobAndPay.none' | translate }}</ng-template>
                    </div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.department' | translate }}</label>
                    </div>
                    <div class="columns-7">
                        <a [routerLink]="['/employees', 'departments', employee?.department?.id]">{{
                            employee?.department?.name
                        }}</a>
                    </div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.position' | translate }}</label>
                    </div>
                    <div class="columns-7">{{ employee?.job?.title }}</div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.officeLocation' | translate }}</label>
                    </div>
                    <div class="columns-7">
                        <a [routerLink]="['/company', 'offices', employee?.office?.id]">{{
                            employee?.office?.fullAddress
                        }}</a>
                    </div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.employmentType' | translate }}</label>
                    </div>
                    <div class="columns-7">
                        {{ employee?.employmentType | appTranslateOptions: employmentTypesDisplay | capitalize }}
                    </div>
                </div>
                <div *permission="viewCompensationPermission" class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.stockOptions' | translate }}</label>
                    </div>
                    <div class="columns-7">
                        <span class="blur"> {{ employee?.stockOptions }} </span>
                    </div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.additionalTerms' | translate }}</label>
                    </div>
                    <div class="columns-7">{{ employee?.additionalTerms }}</div>
                </div>
                <ng-container *ngIf="payrollEnabled">
                    <ng-container *permission="viewPayrollPermission">
                        @if (payrollEmployee) {
                            @if (!payrollEmployee.isWcbExempt) {
                                <div class="app-grid grid-centered margin-bottom-4">
                                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                                        <label>{{
                                            'employees.jobAndPay.applicableWorkersCompensationRate' | translate
                                        }}</label>
                                    </div>
                                    <div class="columns-7 flex align-items-center">
                                        <a
                                            *ngIf="payrollEmployee.applicableWcbRate"
                                            [routerLink]="[
                                                '/payroll/workers-compensations',
                                                payrollEmployee.applicableWcbRate.id,
                                            ]"
                                            >{{ payrollEmployee.applicableWcbRate.name }}</a
                                        >
                                        <span *ngIf="!payrollEmployee.applicableWcbRate">-</span>
                                    </div>
                                </div>
                            }
                            @if (hasBox45FeatureFlag) {
                                <div class="app-grid grid-centered margin-bottom-4">
                                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                                        <label>{{ 'payroll.dental-benefits.employeeProfile.label' | translate }}</label>
                                    </div>
                                    <div class="columns-7 flex align-items-center">
                                        @if (payrollEmployee.box45Value) {
                                            <a [routerLink]="['/payroll/dental-benefits', payrollEmployee.box45Value]">
                                                {{
                                                    'payroll.dental-benefits.employeeProfile.code'
                                                        | translate: { code: payrollEmployee.box45Value }
                                                }}</a
                                            >
                                        } @else {
                                            -
                                        }
                                    </div>
                                </div>
                            }
                        } @else if (employee.activeOnPayroll()) {
                            <!-- Spinner placeholder while retrieving payroll employee data. This avoids data from suddenly appearing on the profile-->
                            <div class="loadable loading margin-bottom-4 payroll-employee-spinner"></div>
                        }
                        <div class="app-grid grid-centered margin-bottom-4">
                            <ui-banner
                                *ngIf="
                                    !hasRqFilled &&
                                    !employee.activeOnPayroll() &&
                                    employee.office?.province === 'QC' &&
                                    isQcSupported
                                "
                                variant="info"
                            >
                                <p [innerHTML]="'employees.jobAndPay.missingRqInfo' | translate"></p>
                            </ui-banner>
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.jobAndPay.payroll' | translate }}</label>
                            </div>
                            <div class="columns-7 flex align-items-center">
                                <ng-container *ngIf="!employee.activeOnPayroll()">
                                    <ui-button
                                        type="primary"
                                        [disabled]="employeeIsOnboarding || cannotAddToPayroll"
                                        (click)="addEmployeeToPayroll()"
                                        >{{ 'employees.jobAndPay.pay' | translate }}
                                    </ui-button>
                                    <a
                                        *ngIf="!employeeIsOnboarding"
                                        [attr.data-tooltip]="'employees.jobAndPay.payEmployeeThroughHumi' | translate"
                                        class="padding-left-2"
                                        >{{ 'employees.jobAndPay.whatsThis' | translate }}</a
                                    >
                                    <a
                                        *ngIf="employeeIsOnboarding"
                                        [attr.data-tooltip]="
                                            'employees.jobAndPay.payEmployeeThroughHumiAfterOnboarding' | translate
                                        "
                                        class="padding-left-2"
                                        >{{ 'employees.jobAndPay.whatsThis' | translate }}</a
                                    >
                                </ng-container>
                                <ng-container *ngIf="employee.activeOnPayroll()">
                                    <ui-badge class="margin-right-2" type="default">{{
                                        'employees.jobAndPay.paying' | translate
                                    }}</ui-badge>

                                    <mat-icon
                                        svgIcon="remove"
                                        matTooltip="{{
                                            'employees.jobAndPay.contactSupportToRemoveEmployeeFromPayroll' | translate
                                        }}"
                                        matTooltipPosition="after"
                                    ></mat-icon>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <app-deprecated-data-field-group-values
                    [group]="getDataFieldGroupByName(defaultGroupFieldNames.employment_information, dataFields, true)"
                    [dataFields]="dataFields"
                    [dataValues]="dataValues"
                ></app-deprecated-data-field-group-values>
            </ui-card>

            <!-- Bank info -->
            <ui-card
                role="group"
                aria-labelledby="banking-info-header"
                [withMargin]="false"
                *permission="viewBankAccountPermission"
                [class.loading]="!isBankAccountLoaded"
            >
                <ui-button type="link" *ngIf="canShowEditBankAccount" (click)="editFormBankAccount.show()" class="edit"
                    >{{ 'employees.jobAndPay.edit' | translate }}
                </ui-button>
                <app-segment-header
                    id="banking-info-header"
                    title="{{ 'employees.jobAndPay.bankAccount' | translate }}"
                ></app-segment-header>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.paymentMethod' | translate }}</label>
                    </div>
                    <div class="columns-7">
                        {{ employee.paymentMethod | appTranslateOptions: paymentMethodDisplay }}
                    </div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.bankInstitution' | translate }}</label>
                    </div>
                    <div class="columns-7">{{ employee?.bankAccount?.institutionNumber }}</div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.bankBranch' | translate }}</label>
                    </div>
                    <div class="columns-7">{{ employee?.bankAccount?.branchNumber }}</div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.jobAndPay.bankAccount' | translate }}</label>
                    </div>
                    <div class="columns-7">{{ employee?.bankAccount?.accountNumber }}</div>
                </div>

                <app-deprecated-data-field-group-values
                    [group]="getDataFieldGroupByName(defaultGroupFieldNames.bank_account, dataFields, true)"
                    [dataFields]="dataFields"
                    [dataValues]="dataValues"
                ></app-deprecated-data-field-group-values>
            </ui-card>

            <ui-card
                role="group"
                aria-labelledby="current-comp-header"
                [withMargin]="false"
                *permission="viewCompensationPermission"
                [class.loading]="!isCurrentCompensationsLoaded"
            >
                <app-segment-header
                    id="current-comp-header"
                    title="{{ 'employees.jobAndPay.currentCompensation' | translate }}"
                ></app-segment-header>
                <div *ngIf="employeeCurrentSalaries.length; else emptyCurrentCompensationState">
                    <div
                        *ngFor="let salary of employeeCurrentSalaries; last as isLast"
                        [ngClass]="{ 'current-compensation-divider margin-bottom-4': !isLast }"
                    >
                        <div class="app-grid margin-bottom-4">
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.jobAndPay.compensationName' | translate }}</label>
                            </div>
                            <div class="columns-7">
                                <span *ngIf="salary?.name && salary?.name !== 'Regular Pay'; else displayRegularPay">
                                    {{ salary.name }}
                                </span>
                            </div>
                        </div>
                        <div class="app-grid margin-bottom-4">
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.jobAndPay.compensationType' | translate }}</label>
                            </div>
                            <div class="columns-7">
                                <ng-container *ngIf="salary?.frequency === 'year'">{{
                                    'employees.jobAndPay.yearly' | translate
                                }}</ng-container>
                                <ng-container *ngIf="salary?.frequency === 'hour'">{{
                                    'employees.jobAndPay.hourly' | translate
                                }}</ng-container>
                            </div>
                        </div>
                        <div class="app-grid margin-bottom-4">
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.jobAndPay.salaryRate' | translate }}</label>
                            </div>
                            <div class="columns-7">
                                <span class="blur"
                                    >{{
                                        salary?.rate
                                            ? (salary.rate | i18nNum: '$')
                                            : ('employees.jobAndPay.notSet' | translate)
                                    }}
                                    {{ employee?.currency }}
                                </span>
                            </div>
                        </div>
                        <div class="app-grid margin-bottom-4">
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.jobAndPay.effectiveDate' | translate }}</label>
                            </div>
                            <div class="columns-7">{{ salary?.effectiveAt | i18nDate: 'short' }}</div>
                        </div>
                        <div *ngIf="showVacationPay" class="app-grid margin-bottom-4">
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.jobAndPay.vacationPay' | translate }}</label>
                            </div>
                            <div class="columns-7">
                                <ng-container *ngIf="salary?.hasVacationPayPercentage; else displayDash">
                                    {{
                                        'employees.jobAndPay.grossPayPerPeriod'
                                            | translate: { percentage: salary.vacationPayPercentage | i18nNum }
                                    }}
                                </ng-container>
                            </div>
                        </div>

                        <div class="app-grid margin-bottom-4">
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.jobAndPay.hoursPerWeek' | translate }}</label>
                            </div>
                            <div class="columns-7">
                                <span>{{ salary?.hoursPerWeek ? (salary.hoursPerWeek | i18nNum) : '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #emptyCurrentCompensationState>
                    <app-empty-state
                        [label]="
                            'employees.jobAndPay.employeeHasNoCompensation'
                                | translate: { firstName: employee?.firstName }
                        "
                        src="/assets/illustrations/piggy-bank.png"
                    >
                    </app-empty-state>
                </ng-template>
            </ui-card>

            <ui-card
                role="group"
                attr.aria-label="{{ 'employees.jobAndPay.compensationHistory' | translate }}"
                [withSpacing]="false"
                [withMargin]="false"
                *ngIf="displayCompensationTable"
            >
                <app-table
                    [isResponsive]="true"
                    [showOffset]="true"
                    [noPadding]="true"
                    [embedded]="true"
                    [showSearch]="false"
                    [useStickyHeader]="false"
                    [table]="table"
                    title="{{ 'employees.jobAndPay.compensationHistory' | translate }}"
                    class="table"
                    (menuItemSelected)="menuAction($event)"
                >
                    <div *ngIf="canCreateCompensation" class="buttons">
                        <ui-button type="link" (click)="navigateToCreateCompensation()"
                            >{{ 'employees.jobAndPay.createCompensation' | translate }}
                        </ui-button>
                    </div>
                    <app-empty-state
                        [label]="
                            !table.hasFiltersApplied()
                                ? ('employees.jobAndPay.thereAreNoCompensationsToDisplay' | translate)
                                : ''
                        "
                        src="/assets/illustrations/piggy-bank.png"
                    ></app-empty-state>
                </app-table>
            </ui-card>

            <ng-container *permission="viewPayrollPermission">
                <ng-container *ngIf="payrollEnabled && employee?.activeOnPayroll()">
                    <ui-card
                        role="group"
                        aria-labelledby="income-type-header"
                        [withMargin]="false"
                        *ngIf="!payrollEmployee"
                        [class.loading]="!payrollEmployee"
                    >
                        <app-segment-header
                            id="income-type-header"
                            title="{{ 'employees.jobAndPay.additionalIncomeTypes' | translate }}"
                        ></app-segment-header>
                    </ui-card>

                    <ng-container *ngIf="payrollEmployee">
                        <ui-card [withMargin]="false" role="group" aria-labelledby="income-type-header">
                            <app-segment-header
                                id="income-type-header"
                                title="{{ 'employees.jobAndPay.additionalIncomeTypes' | translate }}"
                                [allowEdit]="showEditIncomeTypeButton"
                                (edit)="editAdditionalIncome.show()"
                            ></app-segment-header>
                            <div *ngFor="let companyAdditionalIncome of activeCompanyAdditionalIncomes">
                                <div
                                    class="app-grid margin-bottom-4"
                                    *ngIf="companyAdditionalIncome.employeeAdditionalIncomes[0]?.active"
                                >
                                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                                        <label>{{ companyAdditionalIncome.displayName }}</label>
                                    </div>
                                    <div class="columns-7">
                                        {{ companyAdditionalIncome.employeeAdditionalIncomes[0].amount | i18nNum: '$' }}
                                    </div>
                                </div>
                            </div>
                            <ui-button
                                *ngIf="showAddIncomeTypeButton"
                                type="link"
                                (click)="
                                    formAddAdditionalIncome.companyAdditionalIncomes = unusedCompanyAdditionalIncomes;
                                    addAdditionalIncome.show()
                                "
                                >&#43; {{ 'employees.jobAndPay.incomeType' | translate }}
                            </ui-button>
                        </ui-card>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *permission="viewPayrollPermission">
                <ui-card
                    role="group"
                    aria-labelledby="vacation-header"
                    [withMargin]="false"
                    *ngIf="
                        isCurrentCompensationsLoaded &&
                        employeeVacationPayMethod &&
                        payrollEnabled &&
                        employee?.activeOnPayroll()
                    "
                >
                    <ui-button
                        *ngIf="hasEditVacationPayMethodPermission"
                        type="link"
                        class="edit"
                        (click)="shouldEditVacationPayMethodModalBeDisplayed(true)"
                        >{{ 'employees.jobAndPay.edit' | translate }}
                    </ui-button>
                    <app-segment-header
                        id="vacation-header"
                        title="{{ 'employees.jobAndPay.vacationPayMethod' | translate }}"
                    ></app-segment-header>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-3 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.jobAndPay.howToPayOutVacationPay' | translate }}</label>
                        </div>
                        <div
                            *ngIf="
                                employee?.vacationPayMethod === null ||
                                    employee?.vacationPayMethod === 'vacation_accrual';
                                else displayVacationCashCopy
                            "
                            class="columns-7"
                        >
                            {{
                                'employees.jobAndPay.accruedVacationPayWillBeBankedInHumiAndBePaidOutWhenThisEmployeeTakesVacation'
                                    | translate
                            }}
                        </div>
                        <ng-template #displayVacationCashCopy>
                            <div class="columns-7">
                                {{ 'employees.jobAndPay.payoutAccruedVacationPay' | translate }}
                            </div>
                        </ng-template>
                    </div>
                </ui-card>
            </ng-container>

            <ng-container *permission="viewPayrollPermission">
                <ng-container *ngIf="payrollEnabled && employee?.activeOnPayroll()">
                    <ui-card
                        [withMargin]="false"
                        *ngIf="!payrollEmployee"
                        [class.loading]="!payrollEmployee"
                        role="group"
                        aria-labelledby="taxes-header"
                    >
                        <app-segment-header
                            id="taxes-header"
                            title="{{ 'employees.jobAndPay.taxesAndExemptions' | translate }}"
                        ></app-segment-header>
                    </ui-card>

                    <ng-container *ngIf="payrollEmployee">
                        <ui-card [withMargin]="false" role="group" aria-labelledby="taxes-header">
                            <app-segment-header
                                id="taxes-header"
                                title="{{ 'employees.jobAndPay.taxesAndExemptions' | translate }}"
                            ></app-segment-header>
                            <form class="ui form" class="margin-bottom-0">
                                <div *ngIf="payrollEmployee?.taxInformation?.exemptions" class="flex-row">
                                    <mat-slide-toggle
                                        disabled="true"
                                        color="primary"
                                        name="isTaxExempt"
                                        [ngModel]="payrollEmployee.taxInformation.exemptions.isTax"
                                        (ngModelChange)="
                                            payrollEmployee.taxInformation.exemptions.isTax = $event; onSave()
                                        "
                                    ></mat-slide-toggle>
                                    <div>
                                        <h3 class="no-margins">{{ 'employees.jobAndPay.incomeTax' | translate }}</h3>
                                        <p>{{ 'employees.jobAndPay.contributeToIncomeTax' | translate }}</p>
                                    </div>
                                </div>
                                <div class="ui divider"></div>
                                <div *ngIf="payrollEmployee?.taxInformation?.exemptions" class="flex-row">
                                    <mat-slide-toggle
                                        disabled="true"
                                        color="primary"
                                        name="isCppExempt"
                                        [ngModel]="payrollEmployee.taxInformation.exemptions.isCpp"
                                        (ngModelChange)="
                                            payrollEmployee.taxInformation.exemptions.isCpp = $event; onSave()
                                        "
                                    ></mat-slide-toggle>
                                    <div>
                                        <h3 class="no-margins">{{ 'employees.jobAndPay.cppExempt' | translate }}</h3>
                                        <p [innerHTML]="'employees.jobAndPay.contributeToCPP' | translate"></p>
                                    </div>
                                </div>
                                <div class="ui divider"></div>
                                <div
                                    *ngIf="payrollEmployee?.taxInformation?.exemptions"
                                    class="flex-row margin-bottom-0"
                                >
                                    <mat-slide-toggle
                                        color="primary"
                                        [ngModel]="payrollEmployee.taxInformation.exemptions.isEi"
                                        (ngModelChange)="
                                            payrollEmployee.taxInformation.exemptions.isEi = $event; onSave()
                                        "
                                        name="isEiExempt"
                                    ></mat-slide-toggle>
                                    <div>
                                        <h3 class="no-margins">{{ 'employees.jobAndPay.eiExempt' | translate }}</h3>
                                        <p>
                                            {{
                                                'employees.jobAndPay.employersAreResponsibleForDeductingEIPremiums'
                                                    | translate
                                            }}
                                        </p>
                                    </div>
                                </div>
                                <div class="ui divider"></div>
                                <div *ngIf="payrollEmployee?.taxInformation?.exemptions" class="flex-row">
                                    <mat-slide-toggle
                                        color="primary"
                                        name="isWcbExempt"
                                        [ngModel]="payrollEmployee.taxInformation.exemptions.isWcb"
                                        (ngModelChange)="
                                            payrollEmployee.taxInformation.exemptions.isWcb = $event; onSave()
                                        "
                                    ></mat-slide-toggle>
                                    <div>
                                        <h3 class="no-margins">
                                            {{ 'employees.jobAndPay.wcbExempt' | translate }}
                                        </h3>
                                        <p>{{ 'employees.jobAndPay.contributeToWcb' | translate }}</p>
                                    </div>
                                </div>
                                <div class="ui divider"></div>
                            </form>
                        </ui-card>

                        <ui-card
                            role="group"
                            attr.aria-label="{{ 'employees.jobAndPay.taxCredits.header' | translate }}"
                            [withMargin]="false"
                            *ngIf="taxCreditUIImprovementsEnabled"
                        >
                            <app-tax-credit (onDataLoad)="handleTaxCreditDataLoad($event)" />
                        </ui-card>

                        <ui-card
                            role="group"
                            aria-labelledby="legacy-credits-header"
                            [withMargin]="false"
                            *ngIf="shouldShowLegacyTaxCredits"
                        >
                            <app-segment-header
                                id="legacy-credits-header"
                                title="{{ 'employees.jobAndPay.additionalTaxCredits' | translate }}"
                                [collapsible]="true"
                                [collapsed]="true"
                            ></app-segment-header>
                            <table class="ui table">
                                <thead>
                                    <tr>
                                        <th>{{ 'employees.jobAndPay.name' | translate }}</th>
                                        <th>{{ 'employees.jobAndPay.jurisdiction' | translate }}</th>
                                        <th>{{ 'employees.jobAndPay.amount' | translate }}</th>
                                        <th class="collapsing" *ngIf="!taxCreditUIImprovementsEnabled"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let taxCredit of payrollEmployee?.taxInformation?.taxCredits">
                                        <td>{{ taxCredit.name }}</td>
                                        <td>{{ taxCredit.jurisdiction }}</td>
                                        <td>{{ taxCredit.amount | currency }}</td>
                                        <td *ngIf="!taxCreditUIImprovementsEnabled">
                                            <app-context-menu>
                                                <app-context-item
                                                    label="{{ 'employees.jobAndPay.delete' | translate }}"
                                                    (click)="onDeleteLegacyTaxCredit(taxCredit)"
                                                ></app-context-item>
                                            </app-context-menu>
                                        </td>
                                    </tr>
                                    <tr *ngIf="!taxCreditUIImprovementsEnabled">
                                        <td colspan="5">
                                            <ui-button type="link" (click)="createTaxCredit.show()"
                                                >&#43; {{ 'employees.jobAndPay.add' | translate }}</ui-button
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ui-card>

                        <ui-card
                            [withMargin]="false"
                            role="group"
                            aria-labelledby="legacy-TD1-header"
                            *ngIf="shouldShowLegacyTaxCredits"
                        >
                            <app-segment-header
                                id="legacy-TD1-header"
                                (edit)="editFormAdditionalTax.show()"
                                [allowEdit]="!taxCreditUIImprovementsEnabled"
                                title="{{ 'employees.jobAndPay.additionalTaxesToBeDeductedTD1' | translate }}"
                            ></app-segment-header>
                            <div class="app-grid margin-bottom-4">
                                <div class="columns-2 xl-columns-5 xxl-columns-4">
                                    <label>{{ 'employees.jobAndPay.additionalTaxToBeDeducted' | translate }}</label>
                                </div>
                                <div class="columns-7">
                                    {{ payrollEmployee.taxInformation.additionalTaxDeducted }} /
                                    {{ 'employees.jobAndPay.period' | translate }}
                                </div>
                            </div>
                        </ui-card>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container>
                <div *ngIf="!isDataFieldsLoaded" class="ui segment" [class.loading]="!isDataFieldsLoaded"></div>

                <app-data-field-groups
                    *ngIf="dataFields && dataValues && isDataFieldsLoaded"
                    [dataFields]="dataFields"
                    [dataValues]="dataValues"
                    [canEditDataValues]="canEditDataValues"
                    component="job_and_pay"
                    (edit)="onDataFieldEdit($event, editDataFieldsModal)"
                ></app-data-field-groups>
            </ng-container>
        </div>
    </div>
</div>
